import { render, staticRenderFns } from "./noPower.vue?vue&type=template&id=6e8de308&scoped=true&"
import script from "./noPower.vue?vue&type=script&lang=js&"
export * from "./noPower.vue?vue&type=script&lang=js&"
import style0 from "./noPower.vue?vue&type=style&index=0&id=6e8de308&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8de308",
  null
  
)

export default component.exports